import { Box, Stack } from '@mui/material';
import * as React from 'react';
import Service from '../../util/Service';
import ContentPage from '../page/portal/ContentPage';

const ColunaContent = ({  edit, darkMode, pagina}) => {

    const [coluna, setColuna] = React.useState([]);

    React.useEffect(() => {
        buscaPaginaRoot();

    }, [])

    function buscaPaginaRoot() {
        Service.GET('/api/paginaHtml/buscaPorNome/'+ pagina.layout.coluna).then(r => {
            if (r && r.length > 0) {
                console.log(r, ">>>>>>>>", pagina);
                setColuna(r.sort((a,b) => a.index - b.index));
            }
        });
    }

    return (
        <Stack direction="row" spacing={2}>
            {coluna && coluna?.map( (coluna,i) => (
                < ContentPage key={coluna.id+"_"+i} edit={edit} darkMode={darkMode} pagina={coluna} />
            ) )}
        </Stack>
    )
}

export default ColunaContent;
